module.exports = __webpack_public_path__ + "static/img/reward_icon_03.da3a19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/reward_icon_03.png
// module id = jstW
// module chunks = 1